import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/Button';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-24 bg-[#FAF7F5]" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-71">
          {/* Contact Info */}
          <div data-id="element-72">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-[#3D3D3D] mb-6" data-id="element-73">
              {t.contact.title}
            </h2>
            <div className="w-20 h-1 bg-[#C9A96E] mb-10" data-id="element-74" />

            <div className="space-y-8" data-id="element-75">
              <div className="flex items-start gap-4" data-id="element-76">
                <div className="bg-white p-3 rounded-full shadow-sm text-[#8B7E74]" data-id="element-77">
                  <MapPin size={24} data-id="element-78" />
                </div>
                <div data-id="element-79">
                  <h3 className="font-bold text-[#3D3D3D] mb-1" data-id="element-80">
                    {t.contact.address}
                  </h3>
                  <p className="text-gray-600" data-id="element-81">
                    ul. Piękna 15/4
                    <br data-id="element-82" />
                    00-549 Warszawa
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-83">
                <div className="bg-white p-3 rounded-full shadow-sm text-[#8B7E74]" data-id="element-84">
                  <Phone size={24} data-id="element-85" />
                </div>
                <div data-id="element-86">
                  <h3 className="font-bold text-[#3D3D3D] mb-1" data-id="element-87">
                    {t.contact.phone}
                  </h3>
                  <p className="text-gray-600" data-id="element-88">+48 123 456 789</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-89">
                <div className="bg-white p-3 rounded-full shadow-sm text-[#8B7E74]" data-id="element-90">
                  <Mail size={24} data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <h3 className="font-bold text-[#3D3D3D] mb-1" data-id="element-93">
                    {t.contact.email}
                  </h3>
                  <p className="text-gray-600" data-id="element-94">hello@glowstudio.pl</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-95">
                <div className="bg-white p-3 rounded-full shadow-sm text-[#8B7E74]" data-id="element-96">
                  <Clock size={24} data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <h3 className="font-bold text-[#3D3D3D] mb-1" data-id="element-99">
                    {t.contact.hours}
                  </h3>
                  <p className="text-gray-600" data-id="element-100">
                    Mon - Fri: 09:00 - 20:00
                    <br data-id="element-101" />
                    Sat: 10:00 - 16:00
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm" data-id="element-102">
            <form className="space-y-6" data-id="element-103">
              <div data-id="element-104">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-105">
                  {t.contact.name}
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E]/20 outline-none transition-all bg-[#FAF7F5]" data-id="element-106" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-107">
                <div data-id="element-108">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-109">
                    {t.contact.email}
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E]/20 outline-none transition-all bg-[#FAF7F5]" data-id="element-110" />
                </div>
                <div data-id="element-111">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-112">
                    {t.contact.phone}
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E]/20 outline-none transition-all bg-[#FAF7F5]" data-id="element-113" />
                </div>
              </div>

              <div data-id="element-114">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-115">
                  {t.contact.message}
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#C9A96E] focus:ring-2 focus:ring-[#C9A96E]/20 outline-none transition-all bg-[#FAF7F5]" data-id="element-116"></textarea>
              </div>

              <Button className="w-full" data-id="element-117">{t.contact.send}</Button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}